

















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ListModel } from "@/shared/models/listModel";
import { PhotoViewModel } from "./types";
import PhotoTile from "./PhotoTile.vue";
import PhotoForm from "./PhotoForm.vue";
import SortablePhotos from "./SortablePhotosDirective";
import { Notification } from "@/store/modules/notifications";
import FormDescription from "@/components/misc/FormDescription.vue";

@Component({
  components: {
    PhotoTile,
    PhotoForm,
    FormDescription
  },
  directives: {
    SortablePhotos,
  },
})
export default class PhotoEditor extends Vue {
  @Prop() endpoint?: string;
  @Prop() descriptionTextResource?: string;

  photos: PhotoViewModel[] = [];

  mounted() {
    this.getPhotos();
  }

  getPhotos() {
    Vue.axios
      .get<ListModel<PhotoViewModel>>(this.endpoint || "")
      .then((res) => {
        this.photos = res.data.result;
      });
  }

  onSortEnd(evt: any) {
    if (!this.photos) {
      return;
    }

    const photosTmp = this.photos;

    const originItem = photosTmp[evt.oldIndex];
    const targetItem = photosTmp[evt.newIndex];

    const originIndex = photosTmp.indexOf(originItem);
    const targetIndex = photosTmp.indexOf(targetItem);

    photosTmp.splice(targetIndex, 0, photosTmp.splice(originIndex, 1)[0]);

    this.saveOrder();
  }

  saveOrder() {
    const model = {
      photos: this.photos,
    };

    Vue.axios.put(this.endpoint || "", model).then(() => {
      this.$store.dispatch("showNotification", {
        color: "success",
        message: this.$t("Photos.OrderSaved"),
        timeout: 5000,
      } as Notification);
    });
  }

  // upload
  uploading = false;
  dragging = false;
  ignoreDragForUpload = false;
  filesToUpload: any = {};

  add() {
    ((this.$refs.inputRef as Vue).$el.lastElementChild?.firstElementChild
      ?.firstElementChild?.lastElementChild as HTMLElement).click();
  }

  dropFile(e: any) {
    this.dragging = false;

    const imageTypeRegex = new RegExp(/image\/*/);

    for (const file of e.dataTransfer.files) {
      if (!imageTypeRegex.test(file.type)) {
        this.$store.dispatch("showNotification", {
          color: "error",
          message: this.$t("PhotosUpload.NotAllImages"),
          timeout: 5000,
        } as Notification);
        return;
      }
    }
    this.filesToUpload = e.dataTransfer.files;
  }

  @Watch("filesToUpload")
  uploadImages() {
    if (!this.filesToUpload || this.filesToUpload.length == 0) {
      return;
    }

    const formData = new FormData();
    for (let i = 0; i < this.filesToUpload.length; i++) {
      formData.append("images", this.filesToUpload[i]);
    }

    this.uploading = true;
    Vue.axios
      .post(this.endpoint || "", formData)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("PhotosUpload.Success"),
          timeout: 5000,
        } as Notification);

        // this.$emit("uploaded");
        this.getPhotos();
      })
      .finally(() => (this.uploading = false));
  }

  // photo form
  photoFormOpen = false;
  photoForForm: PhotoViewModel | null = null;
  openItemDetails(photo: PhotoViewModel) {
    this.photoForForm = photo;
    this.photoFormOpen = true;
  }

  deletePhoto(photo: PhotoViewModel) {
    this.$store.dispatch("showNotification", {
      id: photo.id,
      color: "warning",
      message: this.$t("DeleteConfirmation") + ` '${photo.filename}'`,
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deletePhotoConfirm(photo);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }
  deletePhotoConfirm({ id }: { id: number }) {
    Vue.axios
      .delete(this.endpoint + `/${id}`)
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Photo.DeleteSuccess"),
          timeout: 5000,
        } as Notification);
      })
      .finally(() => {
        this.getPhotos();
      });
  }
}
